const state = {
    statusOptions: [
        { id: 1, label: '是' },
        { id: 2, label: '否' },
    ],

    cityList: [
        { id: 1, label: '杭州' },
        { id: 2, label: '宁波' },
        { id: 3, label: '温州' },
        { id: 4, label: '绍兴' },
        { id: 5, label: '湖州' },
    ],

    cascaderList: [
        {
            id: 1,
            label: '浙江省',
            children: [{ id: 11, label: '杭州市', children: [] }],
        },
        {
            id: 2,
            label: '江苏省',
            children: [
                {
                    id: 22,
                    label: '苏州市',
                    children: [
                        {
                            id: 222, label: '姑苏区', children: [
                                {
                                    id: 2222, label: '江南大道', children: [],
                                }],
                        }],
                }],
        },
        {
            id: 3,
            label: '四川省',
            children: [{ id: 33, label: '成都市', children: [] }],
        },
    ],

    treeSelectOptionsList: [
        {
            id: 1, text: '中国', children: [
                { id: 11, text: '重庆' },
                { id: 12, text: '四川' },
                { id: 13, text: '贵州' },
            ],
        },
        {
            id: 2, text: '中中国', children: [
                { id: 21, text: '从重庆' },
                { id: 22, text: '从庆' },
                { id: 23, text: '从重' },
                { id: 24, text: '重庆' },
            ],
        },
    ],
}

export default {
    namespace: true,
    state,
}
